import { EnvironmentService } from "@/environment/environmentservice";
import axios from "@/axios-config/default";
import { TrackFile } from './track-file';
import { TrackingEnum } from '@/models/tracking-enum';
export interface ITrack {
    task?: string | null;
    page?: TrackingEnum | null;
    trackFile?: TrackFile | null;
}
export class Track {
    public task!: string | null;
    public page!: TrackingEnum | null;
    public method!: string | null;
    public trackFile!: TrackFile | null;

    public environmentService = new EnvironmentService();

    constructor(track: ITrack) {
        this.task = track.task || null;
        this.page = track.page || null;
        this.trackFile = track.trackFile || null;
    }

    public static empty() {
        return new Track({});
    }

    public toTrackingDto(): any {
        return {
            page: this.page,
            method: this.method,
        };
    }

    public toTrackingWithTaskDto(): any {
        return {
          
        };
    }

    public toTrackingOnlyFile(): any {
        return {
            trackFile: this.trackFile
        };
    }

    public toTrackingWithFileDto(): any {
        return {
            trackFile: this.trackFile,
            method: this.method,
            page: this.page
        };
    }

    public async trackRecordWithFile(): Promise<void> {
        const trackfi = this.toTrackingWithFileDto();
        const toTrack = this.toTrackingOnlyFile();
        await axios.post(this.environmentService.getServicePath("portaltracking"), toTrack, {
            params: {
                page: trackfi.page,
                method: trackfi.method,
                task: trackfi.task
            }
        });

    }

    public async trackRecord(): Promise<void> {
        const trackfi = this.toTrackingDto();
        const toTrack = this.toTrackingWithTaskDto();
        await axios.post(this.environmentService.getServicePath("portaltracking"), toTrack, {
            params: {
                page: trackfi.page,
                method: trackfi.method,
            }
        });
    }
    
    public async trackRecordRequest(request: any): Promise<void> {
        const trackfi = this.toTrackingDto();

        await axios.post(this.environmentService.getServicePath("portaltracking"), request, {
            params: {
                userName: trackfi.userName,
                page: trackfi.page,
                method: trackfi.method,
            }
        });

    }
}









